(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lamplit-first-order-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  const dialog=document.getElementById('LamplitFirstOrderDialog');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const key='lamplit-first-order-offer-dismissed-at';
  const sevenDays=7*24*60*60*1000;
  const dismissed=Number(localStorage.getItem(key)||0);
  const expired=!dismissed||(Date.now()-dismissed)>sevenDays;
  const success=dialog.dataset.success==='true';
  if(success){
    setTimeout(()=>{if(!dialog.open)dialog.showModal();},250);
  }else if(expired){
    const openOffer=()=>{if(!dialog.open)dialog.showModal();};
    setTimeout(openOffer,9000);
    let opened=false;
    const onScroll=()=>{
      if(opened)return;
      const max=document.documentElement.scrollHeight-window.innerHeight;
      if(max>0&&window.scrollY/max>.38){
        opened=true;
        window.removeEventListener('scroll',onScroll);
        openOffer();
      }
    };
    window.addEventListener('scroll',onScroll,{passive:true});
  }
  dialog.querySelector('[data-lf-offer-close]')?.addEventListener('click',()=>{
    localStorage.setItem(key,String(Date.now()));
    dialog.close();
  });
  dialog.addEventListener('cancel',()=>localStorage.setItem(key,String(Date.now())));
})();
  } catch(e) { console.error(e); }
})();

})();
